export const OFFER_PARTNER_INCOME_TYPE_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerIncomeTypeUpdated";
export const OFFER_PARTNER_INCOME_DATA_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerIncomeDataUpdated";
export const OFFER_PARTNER_INCOME_DATA_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerIncomeDataInvalidated";

export const OFFER_PARTNER_SALARY_DATA_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerSalaryDataUpdated";
export const OFFER_PARTNER_SALARY_DATA_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerSalaryDataInvalidated";
export const OFFER_PARTNER_ALL_INCOME_TYPES_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerAllIncomeTypesInvalidated";
